import React, { useEffect } from 'react';
import Select from 'react-select';

import { useGlobalStore } from '@stores/globalStore';

const ShiftsList = ({ did, disabled, onChange, value }) => {
  const shiftList = useGlobalStore((state) => state.shiftList);
  const fetchShiftList = useGlobalStore((state) => state.fetchShiftList);

  useEffect(() => {
    if (!shiftList.length) {
      fetchShiftList();
    }
  }, [fetchShiftList, shiftList.length]);

  const handleChange = (selectedOption) => {
    const id = did || 0;
    const option = selectedOption || { value: '', label: '' };
    onChange(option, id);
  };

  return (
    <Select
      onChange={handleChange}
      isClearable={true}
      options={shiftList}
      className="select-box-container shift-selector-container"
      classNamePrefix="shift-selector"
      name="oml"
      placeholder="Select shift"
      value={shiftList.filter((option) => option.value === value)}
      isDisabled={disabled || false}
      menuPortalTarget={document.body}
    />
  );
};

export { ShiftsList };
